import Cookies from "js-cookie/src/js.cookie"
import jstz from "jstz/dist/jstz"
import { domReady } from "../helpers"

if (!window.BrowserTZone) {
  window.BrowserTZone = {}
}

BrowserTZone.setCookie = () =>
  Cookies.set("_sthr_tz", jstz.determine().name(), {
    expires: 365,
    path: "/",
  })

domReady(BrowserTZone.setCookie)
